import React from 'react';
import NavVisibilitySection from '../components/preferences/NavVisibilitySection';
import NotificationPreferencesSection from '../components/preferences/NotificationPreferencesSection';

const EvidencePreferencesPage = () => {
  return (
    <div className="evidence-preferences">
      <div className="evidence-preferences__body">
        <NavVisibilitySection />
        <NotificationPreferencesSection />
      </div>
    </div>
  );
};

export default EvidencePreferencesPage;
